"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _Event = _interopRequireDefault(require("../../../darkmatter/Event"));

var _default = function _default(_ref) {
  var category = _ref.category,
      displayCategoriesAs = _ref.displayCategoriesAs;

  if (displayCategoriesAs === 'button') {
    return /*#__PURE__*/_react["default"].createElement(_Event["default"], {
      event: {
        category: 'Menu Navigation',
        action: 'Click',
        label: category
      },
      eventType: "click"
    }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
      primary: true,
      as: "a",
      href: "#".concat(category)
    }, category));
  }

  if (displayCategoriesAs === 'text') {
    return /*#__PURE__*/_react["default"].createElement(_Event["default"], {
      event: {
        category: 'Menu Navigation',
        action: 'Click',
        label: category
      },
      eventType: "click"
    }, /*#__PURE__*/_react["default"].createElement("a", {
      href: "#".concat(category)
    }, category));
  }

  return /*#__PURE__*/_react["default"].createElement(_Event["default"], {
    event: {
      category: 'Menu Navigation',
      action: 'Click',
      label: category
    },
    eventType: "click"
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Header, {
    as: "a",
    href: "#".concat(category)
  }, category));
};

exports["default"] = _default;